module.exports = __webpack_public_path__ + "img/vue2-toebox_rouge.8c2db65f.png";